// 3rd party imports
import * as React from 'react';
import { Link, Redirect, withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { RouteComponentProps } from 'react-router';

// ui
import { UitkSubheading, UitkHeading, UitkText } from 'uitk-react-text';
import { UitkCard } from 'uitk-react-cards';
import { UitkSpacing, UitkSpacingHr } from 'uitk-react-spacing';
import { UitkLink } from 'uitk-react-link';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkFigure, UitkImage } from 'uitk-react-images';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { UitkFloatingActionButton, UitkPrimaryButton, UitkSecondaryButton, UitkButtonSize } from 'uitk-react-button';
import { UitkList, UitkListItem } from 'uitk-react-list';
import { UitkFakeInput } from 'uitk-react-input';

// bernie
import { ContextStore } from 'bernie-core';
import { ILocalization, withLocalization } from '@shared-ui/localization-context';

// util
import { modifyLocaleParam } from '../../util/LocaleParamTransformer';
import { LocalizedText } from 'bernie-l10n';

export interface PzSignUpConfProps extends RouteComponentProps {
  context?: ContextStore;
  l10n?: ILocalization;
}

export interface PzSignupConfState {
  copied: boolean;
}

@withLocalization
@inject('context', 'l10n')
@observer
export class PzSignupConfirmation extends React.Component<PzSignUpConfProps, PzSignupConfState> {
  public constructor(props) {
    super(props);
    this.state = {
      copied: false,
    };
  }

  private partnerizeSiteLink = 'https://console.partnerize.com/login/phg/en';
  private zendeskLink='https://egaffiliates.zendesk.com/hc/en-us/articles/1500003709001-FAQ-Partnerize-and-the-Affiliate-Hub';
  private moreLinks = '/quicklinks?programName=';
  private viewProductsLink = '/products';

  private setTimer = () => {
    this.setState({
      copied: true,
    });
    setTimeout(() => {
      this.setState({
        copied: false,
      });
    }, 2000);
  };

  private copyBtnOnClick = (copy) => {
    navigator.clipboard.writeText(copy);
    this.setTimer();
  };

  public render() {
    let camRef = null;
    let partnerId = null;
    let program = null;

    if (this.props.location.state) {
      camRef = this.props.location.state['camRef'];
      partnerId = this.props.location.state['partnerId'];
      program = this.props.location.state['program'];
    }

    if (camRef == null || partnerId == null) {
      return <Redirect to={`/${modifyLocaleParam(this.props.context.locale)}/home`} />;
    }

    const getTrackingLink = (partner, camref) => {
      return `https://vrbo.prf.hn/click/camref:${camref}/destination:https://www.vrbo.com`;
    };

    return (
      <>
        <UitkSpacing className="container" padding={{ block: 'twelve' }}>
          <main>
            <UitkSpacing margin={{ blockend: 'six' }} className="PzSignupConfirmation__title">
              <UitkHeading tag="h1" size={2}>
                <LocalizedText message="pz.signup.post_registration.title.your_partnerize_account_has_been_created_and_you_are_approved_for_the_program" data={[program.title]} />
              </UitkHeading>
            </UitkSpacing>

            <UitkSpacing margin={{ blockstart: 'two', blockend: 'six' }}>
              <UitkCard overflow={false} padded={true} className="PzSignupConfirmation__hero">
                <UitkSpacing margin={{ blockend: 'four' }}>
                  <div>
                    <UitkHeading tag="h2" size={5}>
                      <LocalizedText message="pz.signup.post_registration.section.pz_registration_details.your_partnerize_partner_id_is" />
                    </UitkHeading>
                    <UitkSubheading tag="h4">{partnerId}</UitkSubheading>
                  </div>
                </UitkSpacing>
                <div>
                  <UitkHeading tag="h2" size={5}>
                    <LocalizedText message="pz.signup.post_registration.section.pz_registration_details.your_vrbo_program_tracking_code_camref_is" data={[program.title]} />
                  </UitkHeading>
                  <UitkSubheading tag="h4">{camRef}</UitkSubheading>
                </div>
              </UitkCard>
            </UitkSpacing>

            <UitkSpacingHr />

            <UitkSpacing margin={{ blockstart: 'twelve', blockend: 'four' }}>
              <UitkHeading tag="h1" size={4}>
                <LocalizedText message="pz.signup.post_registration.section.tracking_link.title.your_basic_tracking_link_is" />
              </UitkHeading>
            </UitkSpacing>

            <UitkSpacing margin={{ blockend: 'six' }}>
              <div>
                <UitkLayoutFlex space="two" className="PzSignupConfirmation__copy-input">
                  <UitkFakeInput label="Tracking link" value={`${getTrackingLink(partnerId, camRef)}`} />
                  <UitkSecondaryButton
                    className="PzSignupConfirmation__copy-btn"
                    onClick={() => this.copyBtnOnClick(getTrackingLink(partnerId, camRef))}
                    size={UitkButtonSize.LARGE}
                  >
                    {this.state.copied ? 'Copied' : 'Copy'}
                  </UitkSecondaryButton>
                </UitkLayoutFlex>
              </div>
            </UitkSpacing>

            <UitkSpacing margin={{ blockend: 'six' }}>
              <UitkPrimaryButton
                type="button"
                tag={'a'}
                href={`/${modifyLocaleParam(this.props.context.locale)}${this.moreLinks}${program.name}`}
              >
                <LocalizedText message="pz.signup.post_registration.section.tracking_link.button.see_more_links_configure_your_own" />
              </UitkPrimaryButton>
            </UitkSpacing>

            <UitkSpacing margin={{ blockstart: 'six', blockend: 'two' }}>
              <UitkHeading tag="h1" size={4}>
                <LocalizedText message="pz.signup.post_registration.section.next_steps.title.next_steps" />
              </UitkHeading>
            </UitkSpacing>

            <UitkList type="ordered" className="PzSignupConfirmation__steps">
              <UitkListItem>
                <LocalizedText message="pz.signup.post_registration.section.items.item1.go_to" />&nbsp;
                <UitkLink inline={true} data-stid="go-to-products">
                  <Link
                    to={`/${modifyLocaleParam(this.props.context.locale)}${this.viewProductsLink}?programName=${
                      program.name
                    }`}
                    target="_self"
                  >
                    <LocalizedText message="pz.signup.post_registration.section.items.item1.products" />
                  </Link>
                </UitkLink>
                <LocalizedText message="pz.signup.post_registration.section.items.item1.get_all_your_tracked_links_and_start_promoting" />
              </UitkListItem>
              <UitkListItem>
                <LocalizedText message="pz.signup.post_registration.section.items.item2.log_into" />&nbsp;
                <UitkLink inline={true}>
                  <a href={this.partnerizeSiteLink} target="_blank">
                    Partnerize.com
                  </a>
                </UitkLink>
                &nbsp;<LocalizedText message="pz.signup.post_registration.section.items.item2.add_your_bank_details_so_that_we_can_pay_you" />
                <br />
                <LocalizedText message="pz.signup.post_registration.section.items.item2.you_should_have_received_partnerize_welcome_email" />
              </UitkListItem>
              <UitkListItem>
                <LocalizedText message="pz.signup.post_registration.section.next_steps.items.item3.find_answers_to_common_questions" />&nbsp;
                <UitkLink inline={true}>
                  <a href={this.zendeskLink} target="_blank">
                    <LocalizedText message="pz.signup.post_registration.section.next_steps.items.item3.here" />
                  </a>
                </UitkLink>.
                <br />
              </UitkListItem>
            </UitkList>
          </main>
        </UitkSpacing>
      </>
    );
  }
}

export const PzWithRouter = withRouter(PzSignupConfirmation);
